import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './TrustedSourcesModal.styles';
import { WebsiteCard } from './WebsiteCard';

const staticWebsites = [
  {
    title: 'Bloomberg News',
    url: 'www.bloomberg.com',
    favicon: '/app/static/images/logotypes/bloomberg.svg',
  },
  {
    title: 'Financial Times',
    url: 'www.ft.com',
    favicon: '/app/static/images/logotypes/financial-times.svg',
  },
];

interface TrustedSourcesModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const TrustedSourcesModal = ({
  isOpen,
  onClose,
}: TrustedSourcesModalProps) => {
  const { t } = useTranslation(['chat']);

  return (
    <S.StyledModal
      isOpen={isOpen}
      onClose={onClose}
      title={t('chat:trustedSources.modal.title')}
      description={t('chat:trustedSources.modal.description')}
      data-testid="trusted-sources-modal"
    >
      <S.Content>
        {staticWebsites.map(website => (
          <WebsiteCard key={website.url} {...website} />
        ))}
      </S.Content>
    </S.StyledModal>
  );
};
